import common from '../common/common'
import fetch from "../common/util"


export default {
    // 发送确认信
    sendEmail: function (oid, uemail) {
        return fetch.get(common.GetAppVar().A_SEND_EMAIL, { "order_id": oid, "user_email": uemail });
    },
    // 订单取消
    cancleOrder:function (oid,code) {
        return fetch.get(common.GetAppVar().A_ORDER_CANCLE, { "order_id": oid,"code":code});
    },
    // 订单提交
    submitOrder: function (postData) {
        return fetch.get(common.GetAppVar().A_CONFIRM_ORDER_N, postData);
    },
    // 订单明细
    checkOrder: function (oid) {
        return fetch.get(common.GetAppVar().A_ORDER_PAY, { "orders_id": oid });
    },
    // 轮询订单状态
    checkStatus: function (oid) {
        return fetch.get(common.GetAppVar().A_ORDER_STATUS, { "order_id": oid });
    },
    // 全部订单
    searchOrder: function (params) {
        return fetch.get(common.GetAppVar().A_ORDER_LIST, params);
    },
    // 提现历史列表
    searchCashList: function (page_num) {
        let params = {
            page: page_num,
            page_size: 10
        }
        return fetch.get(common.GetAppVar().A_CASH_LIST, params);
    },
    // 申请提现
    applyForCash: function (applyParam) {
        return fetch.get(common.GetAppVar().A_CASH_APPLY, applyParam);
    },
    // 发票列表
    searchInvoiceList: function (page_num) {
        let params = {
            page: page_num,
            page_size: 10
        }
        return fetch.get(common.GetAppVar().A_INVOICE_LIST, params);
    },
    // 申请发票
    applyInvoice: function (applyParam) {
        return fetch.get(common.GetAppVar().A_INVOICE_APPLY, applyParam);
    },
    // 四个月佣金
    searchFourCash: function () {
        return fetch.get(common.GetAppVar().A_FOUR_MONTH);
    },
    // 收藏/取消
    handleCollect:function(hid,act){
        return fetch.get(common.GetAppVar().A_COLLECTE_HOTEL,{"hotel_id":hid,"action":act});
    },
    // 收藏列表
    searchCollection:function(pageNum){
        return fetch.get(common.GetAppVar().A_COLLECTE_LIST,{"page":pageNum,"page_size":12});
    },
}


// WEBPACK FOOTER //
// ./src/api/order.js